import classNames from 'classnames';
import React, { useContext } from 'react';

import { parseLink } from './../../ricos-content/lib/nodeUtils';
import { ToolbarContext } from './../../ricos-context';
import type { IToolbarItem } from './../../ricos-types';
import { EditorBaseUrlContext } from './../../_shared/editor-base-url/editor-base-url-context';
import { getEditableUrl } from './../../_shared/url/get-editable-url';
import { getHrefUrl } from './../../_shared/url/get-href-url';

import styles from './url-link-button-scss';

export const UrlLinkButton = ({ toolbarItem }: { toolbarItem: IToolbarItem }) => {
  const { baseUrl } = useContext(EditorBaseUrlContext);
  const { isMobile } = useContext(ToolbarContext);

  const selectedUrlLinkData = toolbarItem.attributes.selectedUrlLinkData;
  const dataHook = toolbarItem.presentation?.dataHook;
  const { url = '', rel = '', target = '_self' } = parseLink(selectedUrlLinkData);
  const editableUrl = getEditableUrl(url, baseUrl);
  const hrefUrl = getHrefUrl(url, baseUrl);

  return (
    <div className={styles.toolbarUrlContainer}>
      <a
        data-hook={dataHook}
        href={hrefUrl}
        rel={rel}
        target={target}
        className={classNames(styles.toolbarUrl, isMobile && styles.isMobile)}
        onMouseDown={event => event.preventDefault()}
      >
        {editableUrl}
      </a>
    </div>
  );
};
